/**
 * Japanese labels for the massager checkin portal.
 * Centralised so future translations (or site-specific overrides) stay cheap.
 */
export const MASSAGER_JA = {
  status: {
    none: '未訪問',
    now: '施術中',
    done: '施術完了',
  },
  action: {
    start: '施術開始',
    done: '施術完了',
    cancel: '訪問解除',
    save: '保存',
    back: '戻る',
    gpsAdd: 'GPSで追加',
    mapLink: '地図',
    addVisit: '訪問追加',
    retry: '再試行',
    refresh: '更新',
    prevDay: '前日',
    today: '今日',
    nextDay: '翌日',
  },
  confirm: {
    cancel: '本当に解除しますか？',
  },
  empty: '訪問予定はありません。',
  error: {
    geolocationUnavailable: '現在地を取得できません。GPSを有効にしてください。',
    geolocationDenied: '位置情報取得できませんでした。',
    geolocationTimeout: '現在地の取得がタイムアウトしました。',
    noNearbyPatient: '近くに登録済みの受診者が見つかりません。',
    multipleNearbyPatient: '近くに複数の受診者が見つかりました。受診者を選択してください。',
  },
  label: {
    patient: '受診者',
    address: '住所',
    memo: '施術メモ',
    time: '時間',
    duration: '所要時間',
    actualTime: '実績',
  },
} as const;

export type MassagerJa = typeof MASSAGER_JA;
